import { useEffect, useRef, useState } from 'react';
import { getOptionalEstimate } from 'helpers/estimate';
import money from 'helpers/money';
import useDisplayValue from 'hooks/useDisplayValue';
import styles from 'styles/ReservationResume.module.css';
import { EstimateOptionalType } from '@/helpers/optionals';
import { Estimate } from '@/types/coral-types';
import { useReservation } from '@/contexts/reservation';

export type OptionalProps = {
  optional: EstimateOptionalType;
  estimate: Estimate;
  usePipe?: boolean;
};

export default function Optional({ optional, estimate, usePipe }: OptionalProps) {
  const { isEstimateLoading } = useReservation();
  const [opEstimate, setOpEstimate] = useState({
    code: '',
    quantity: 0,
    total: 0,
  });

  const titleRef = useRef<string | undefined>(optional.optional?.title);

  const [cachedTitle, setCachedTitle] = useState<string | undefined>(optional.optional?.title);

  const display = useDisplayValue({
    width: 150,
  });

  useEffect(() => {
    const newTitle = optional.optional?.title;
    if (newTitle) {
      setCachedTitle(newTitle);
      titleRef.current = newTitle;
    }
  }, [optional.optional?.title]);

  useEffect(() => {
    setOpEstimate(getOptionalEstimate(estimate, optional.code!));
  }, [estimate, optional.code]);

  const displayTitle = cachedTitle || titleRef.current || (optional.code === '__basic__' ? 'Proteção Básica' : '');
  const isBasic = optional.code === '__basic__';

  return (
    <div className={styles.item__inner}>
      <div className={styles.item__data__wrap}>
        <p className={styles.item__data__title__resume}>{displayTitle}</p>
        <div className={styles.item__data__value}>
          {usePipe !== false && <hr className={styles.header__diveder} />}
          {isBasic ? (
            display('Incluso', isEstimateLoading)
          ) : optional.optional && optional.optional.rate_type === 'rental days' ? (
            <>
              {display(
                `30x de ${money(opEstimate.total / 30)} = ${money(
                  opEstimate.total,
                )}`,
                isEstimateLoading,
              )}
            </>
          ) : (
            display(money(opEstimate.total), isEstimateLoading)
          )}
        </div>
      </div>
    </div>
  );
}
